var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import * as ReactDOM from "react-dom";
import { defineCustomTags } from "sb-resp-lib";
defineCustomTags("sb-resp-popup-portal");
var PopupPortal = /** @class */ (function (_super) {
    __extends(PopupPortal, _super);
    function PopupPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.portalElem = document.createElement("sb-resp-popup-portal");
        _this.portalElem.className = "rj-popup-portal " + props.className;
        return _this;
    }
    PopupPortal.prototype.componentWillUnmount = function () {
        this
            .props
            .popupPortalEl
            .removeChild(this.portalElem);
    };
    PopupPortal.prototype.componentDidMount = function () {
        this
            .props
            .popupPortalEl
            .appendChild(this.portalElem);
    };
    PopupPortal.prototype.render = function () {
        return (ReactDOM.createPortal(this.props.children, this.portalElem));
    };
    return PopupPortal;
}(React.Component));
export { PopupPortal };
//# sourceMappingURL=PopupPortal.js.map